module.exports = __webpack_public_path__ + "static/media/MATIC    -logo.5402f6c9.png";